import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../../../../store/user/selectors";
import { updateConversation } from "../../../../store/chats/thunks";
import Modal from "../../../../components/generic/Modal";
import PhoneInput from "../../../../components/shared/PhoneInput";
import { Alert, Form, message, Result } from "antd";
import { ROUTES } from "../../../../constant/routes";

const AddMembers = (props) => {
  const [form] = Form.useForm();
  const {
    onCancel,
    selectedChat: { id: conversation_id },
    customers,
  } = props;
  const [submitting, setSubmitting] = useState(false);
  const tenant_id = useSelector(selectSelectedTenantId);
  const [showError, setShowError] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = useCallback(
    async (values) => {
      try {
        const isAlreadyExists = customers?.some(
          (member) =>
            member?.phone === values?.mobile_number?.phone &&
            member?.phone_country_code ===
              values?.mobile_number?.phone_country_code,
        );

        if (isAlreadyExists) {
          message.warning(
            "This mobile number already exists in the conversation.",
          );
          return;
        }

        setShowError(false);
        setSubmitting(true);

        const result = await dispatch(
          updateConversation({
            payload: {
              conversation_id,
              add: [values?.mobile_number],
              tenant_id,
            },
            addedUsers: [values?.mobile_number],
          }),
        );

        if (!result?.error?.message) {
          message.success("Member added successfully.");
          onCancel();
        } else {
          setShowError(true);
        }
      } catch (error) {
        console.log("🚀 ~ AddMembers.jsx:30 ~ AddMembers ~ error:", error);
      } finally {
        setSubmitting(false);
      }
    },
    [conversation_id, tenant_id, customers],
  );
  return (
    <Modal
      title={`Add member in to selected conversion`}
      onCancel={onCancel}
      width={480}
      open
      onOk={() => form.submit()}
      isProcessing={submitting}
    >
      <Form
        form={form}
        layout="vertical"
        disabled={submitting}
        onFinish={handleSubmit}
      >
        <PhoneInput split />
      </Form>
      {showError && (
        <Alert
          type="error"
          showIcon
          title="Everything is better with a team."
          description={
            <>
              Invite {form.getFieldValue("mobile_number").phone_country_code}-
              {form.getFieldValue("mobile_number").phone} to sign up and start
              collaborating on Kelu today.{" "}
              <a
                href={`${window.location.origin}${ROUTES.SIGNUP}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Click to Invite
              </a>
            </>
          }
        />
      )}
    </Modal>
  );
};
export default AddMembers;
